import { render, staticRenderFns } from "./OneIssue.vue?vue&type=template&id=6283785f&scoped=true"
import script from "./OneIssue.vue?vue&type=script&lang=js"
export * from "./OneIssue.vue?vue&type=script&lang=js"
import style0 from "./OneIssue.vue?vue&type=style&index=0&id=6283785f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6283785f",
  null
  
)

export default component.exports